import { z } from 'zod';

import { LOGIN_UNAUTHORIZED_ERROR_CODES } from '../consts';

const PasswordResetRequiredErrorSchema = z.object({
  errors: z.object({
    code: z.literal(LOGIN_UNAUTHORIZED_ERROR_CODES.PASSWORD_RESET_REQUIRED)
  })
});

/** True when the login 401 payload says the account must reset its password before it can sign in. */
export const hasPasswordResetRequiredError = (error: unknown) =>
  PasswordResetRequiredErrorSchema.safeParse(error).success;
